module.exports = __webpack_public_path__ + "img/download.acaa18b0.svg";